module.exports = __webpack_public_path__ + "images/business-class/feature-powerups.99f6c146243e939e36d8.svg";